import { useContext, useEffect, useCallback, useMemo } from 'react';
import Skeleton from '@mui/material/Skeleton';
import { Helmet } from 'react-helmet-async';
import { useObjectAccessModal } from '@/components/ObjectAccess';
import { ObjectAccessContainer } from '@/containers/ObjectAccess/ObjectAccessContainer';
import { useUploadQuantAnalysisFileModal } from '@/containers/QuantAnalysis/hooks';
import { useAppSelector } from '@/store';
import { ProjectDetailsContext, ProjectStateLoadingContext } from './Context';
import styles from './style/ProjectHeader.module.css';

type Props = {
  children?: React.ReactNode;
};

export const Header = (props: Props) => {
  const projectDetails = useContext(ProjectDetailsContext);
  const projectId = projectDetails?.query.data?.project?.id;

  // Only initialize the modal hook when we have a valid projectId
  const [toggleUploadModal, UploadModal] = useUploadQuantAnalysisFileModal({
    projectId,
  });

  return (
    <div className={styles.root}>
      <div className={styles.wrap}>
        <div className={styles.main}>

          {/* <Breadcrumbs /> */}

          <div className={styles.details}>
            <div className={styles.info}>

              <div className={styles.header}>
                <Title />
                <div className={styles.actions}>
                  <ManageAccessButton />
                </div>
              </div>

            </div>

            {props.children}
          </div>

        </div>
      </div>
      {/* Only render modal if we have a valid projectId */}
      {projectId && UploadModal}
    </div>
  );
};

const Title = (props: unknown) => {
  const isLoading = useContext(ProjectStateLoadingContext);
  const ctx = useContext(ProjectDetailsContext);
  const group = useAppSelector(state => state.group.id);

  const title = useMemo(() => {
    //Demo Hardcoding
    if (ctx.query?.data?.project?.id === 2 && group === 222) {
      return 'Medical Affairs Dashboard';
    }
    //Demo Hardcoding
    else if (ctx.query?.data?.project?.id === 2 && group === 218) {
      return 'Case-Level Insights Dashboard';
    }
    else if (ctx.query?.data?.project?.name) {
      return ctx.query?.data?.project?.name;
    }
    else return null;
  }, [ctx.query?.data?.project?.id, ctx.query?.data?.project?.name, group]);

  if (isLoading || !ctx.query?.data?.project) {
    return (
      <Skeleton
        style={{ marginRight: 10 }}
        height={30}
        width={400}
        variant="rectangular" />
    );
  }

  return (
    <>
      <Helmet title={title} />
      <h1 className={styles.title}>{title}</h1>
    </>
  );
};

const ManageAccessButton = () => {
  const isLoading = useContext(ProjectStateLoadingContext);
  const ctx = useContext(ProjectDetailsContext);
  const [toggleAccessModal, ObjectAccessModal] = useObjectAccessModal();

  if (isLoading || !ctx.query?.data?.object) {
    return (
      <Skeleton
        height={40}
        width={40}
        variant="circular" />
    );
  }

  return (
    <>
      <ObjectAccessContainer
        objectId={ctx.query.data.object.id}
        workspaceId={ctx.query.data.object.workspaceId}>
        <ObjectAccessModal />
      </ObjectAccessContainer>
    </>
  );
};